import {
    GameInstanceBase,
    Inject,
    IPreloadersConfiguration,
    ISimpleControllerConfiguration,
} from '@denishussar/html5-game-engine';
import { IRootControllerOptions, RootController } from './RootController';
import { PreloaderGameController } from './Controllers/PreloaderGameController';
import { GameModel } from './Models/GameModel';
import { IVersionControllerOptions, VersionController } from './VersionController';
import { LoaderGameController } from './Controllers/LoaderGameController';

export class GameInstance extends GameInstanceBase {
    @Inject private $model: GameModel;

    public constructor(@Inject options: any) {
        super();

        this.shadowUpdateEnabled = true;
    }

    protected onContentLoaded() {
        super.onContentLoaded();
    }

    protected onCreate(): void {}

    protected getConfiguration(): ISimpleControllerConfiguration {
        return {
            childControllers: {
                rootController: {
                    controller: RootController,
                    model: this.$model,
                    options: <IRootControllerOptions>{
                        version: this.version,
                    },
                },
                version: {
                    controller: VersionController,
                    options: <IVersionControllerOptions>{
                        version: this.version,
                    },
                },

            },
        };
    }

    protected getPreloadersConfiguration(): IPreloadersConfiguration {
        return {
            childControllers: {
                loading: {
                    controller: LoaderGameController,
                    model: this.$model
                },
                preloader: {
                    controller: PreloaderGameController,
                },
            },
        };
    }

    onUpdate():void {

    }

    protected onLandscape(): void {}

    protected onInitialize(): void {
       this.showLoadingTimeout = 1;
       this.showLoading(true);
    }

    protected onPortrait(): void {}
}
